import React from 'react';
import CheckoutComponent from './CheckoutComponent';
import { useParams } from 'react-router-dom';

const CheckoutOnboarding = ({ showOptions }) => {
  const { plan } = useParams();
  const [planId, setPlanId] = React.useState(0);
  const [mailingOption, setMailingOption] = React.useState(0);

  React.useEffect(() => {
    if (plan === 'standard') {
      setPlanId(1);
      setMailingOption(2);
    } else if (plan === 'enhanced') {
      setPlanId(2);
      setMailingOption(2);
    } else {
      //console.log('Redirect the user to onboarding page or goback if history');
    }
  }, []);

  return (
    <React.Fragment>
      <CheckoutComponent showOptions={showOptions} plan={planId} mailing={mailingOption} />
    </React.Fragment>
  );
};

export default CheckoutOnboarding;
